import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { TimeConstants } from '../../../constants/time';
import { handleError } from '../../../utils/common';
import { useAlertModal } from '../../../utils/hook/hook';
import type { BenefitEligibilityRes } from '../dto/response/app-onboarding-benefit.res.dto';
import { UserApi } from '../user.api';

/**
 * 앱 첫설치 혜택 팝업 노출 여부 조회 훅 (웹→앱 유도 모달 게이트).
 * 호출 조건(웹·로그인·모바일 등)은 options.enabled로 제어한다.
 */
const useAppInstallBenefitEligibilityQuery = (
  options?: Omit<
    UseQueryOptions<BenefitEligibilityRes>,
    'queryKey' | 'queryFn' | 'meta'
  >,
) => {
  const { openAlertModal } = useAlertModal();

  const queryResult = useQuery({
    queryKey: UserApi.queryKeys.getAppInstallBenefitEligibility(),
    queryFn: () => UserApi.getAppInstallBenefitEligibility(),
    staleTime: TimeConstants.FIVE_MINUTES,
    meta: {
      onError: (error: unknown) =>
        handleError(openAlertModal, error, '앱 설치 혜택 노출 여부 확인'),
    },
    ...options,
  });

  return { ...queryResult, eligible: queryResult.data?.eligible ?? false };
};

export default useAppInstallBenefitEligibilityQuery;
